import URI from 'urijs'

const url = new URI()

export default {
  hidePoweredBy: url.hasQuery('hidePoweredBy', 'true'),
  hideContactInfo: url.hasQuery('hideContactInfo', 'true'),
  hideLTName: url.hasQuery('hideLTName', 'true'), // Hide LiveTour name
  hideViewNum: url.hasQuery('hideViewNum', 'true'),
  hideLike: url.hasQuery('hideLike', 'true'),
  hideComment: url.hasQuery('hideComment', 'true'),
  hideSearch: url.hasQuery('hideSearch', 'true'),
  showComment: url.hasQuery('showComment', 'true'),
  hideFullscreen: url.hasQuery('hideFullscreen', 'true'),
  showFullscreen: url.hasQuery('showFullscreen', 'true'),
  hideVRMode: url.hasQuery('hideVRMode', 'true'),
  hideGyro: url.hasQuery('hideGyro', 'true'),
  hideShare: url.hasQuery('share', 'hidden'),
  toAutoPilot: url.hasQuery('autopilot', 'true'),
  notToAutoRotate: url.hasQuery('autorotate', 'false'),
  showSearch: url.hasQuery('showSearch', 'true')
}
